/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventvisibilitymembers2Inputs */

const en_eventvisibilitymembers2 = /** @type {(inputs: Eventvisibilitymembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members only`)
};

const de_eventvisibilitymembers2 = /** @type {(inputs: Eventvisibilitymembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Mitglieder`)
};

/**
* | output |
* | --- |
* | "Members only" |
*
* @param {Eventvisibilitymembers2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventvisibilitymembers2 = /** @type {((inputs?: Eventvisibilitymembers2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventvisibilitymembers2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventvisibilitymembers2(inputs)
	return de_eventvisibilitymembers2(inputs)
});
export { eventvisibilitymembers2 as "eventVisibilityMembers" }